import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Avatar } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

//left and right button for prev and next carousel
const PreviousBtn = (props) => {

    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <ArrowBackIos style={{ color: "gray", fontSize: "45px" }} />
        </div>
    );
};

const NextBtn = (props) => {
    const { className, onClick } = props;
    return (
        <div className={className} onClick={onClick}>
            <ArrowForwardIos style={{ color: "gray", fontSize: "45px" }} />
        </div>
    );
};

export default function Testimonial() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        AnimationSpeed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    return (
        <section className="">
            <Slider prevArrow={<PreviousBtn />} nextArrow={<NextBtn />} dots>
                <Container
                    profilePicture={""}
                    content="“With Salesforce as our partner, we trust them to take us on a journey to success.”"
                    name="Mrs. Eunice Baah,"
                    role={"Project Manager, Agrico Hub"}
                ></Container>
                <Container
                    profilePicture={""}
                    content="“We've develop a strong attachment wtih DEEPBLUE which we believe, we can create extraordinary experiences for our customers and that will leapfrog us to a modern company standard.”"
                    name="Edwin Osei,"
                    role={"C.E.O, Tesfarm"}
                ></Container>
            </Slider>
        </section>
    );
}

const Container = ({ profilePicture, content, name, role }) => {
    return (
        <div className="testimonial-container">
            <div className="avatar mb-2">
                <Avatar
                    src={profilePicture}
                    style={{
                        width: 120,
                        height: 120,
                        border: "5px solid #f8f8f8",
                    }}
                />
            </div>
            <p className="slider-text">{content}</p>
            <div className="n-titleame ">
                <h3
                    className="flex text-primary mt-2 mb-3"
                >
                    {name}
                    <span
                        className="text-primary ml-1 text-primary-green"
                    >
                        {role}
                    </span>
                </h3>
            </div>
        </div>
    );
};
